





















































    import {Component, Mixins, Prop, Vue, Watch} from "vue-property-decorator";
    import {Route} from "vue-router";
    import {TrackingService} from "@/services/tracking.service";
    import {User} from "@/services/auth.service";
    import ServiceService from "../services/service.service";
    import ConfigMixin from "../mixins/ConfigMixin";
    import WebUtils from "hcore/dist/webUtils"

interface IMenuItem {
    label: string;
    link: string;
    active: boolean;
    icon?: string;
    privilege?: string;
    toggled?: boolean;
    parent?: IMenuItem;
    children?: IMenuItem[] | (() => Promise<IMenuItem[]>);
}

@Component({
    name: "Navigator"
})
export default class Navigator extends Mixins(ConfigMixin) {

    @Prop()
    public user!: User;

    private currentItem: IMenuItem | undefined;
    private tracking!: TrackingService;

    private hoveredItem: IMenuItem | undefined;
    private toggledItem: IMenuItem | undefined;

    private menuItems: IMenuItem[] = [
        { label: "Home", link: "/", active: false },
        { label: "Services", link: "/service", toggled: true, active: false, children: async () => {
            const services = new ServiceService();
            const res = await services.get();
            if (res.success) {
                return res.result.map(service => {
                    return {
                        label: service.name,
                        link: '/service/' + service.slug,
                        active: false,
                        icon: service.icon,
                    }
                }) 
            } else {
                return [];
            }
        }},
        { label: "Projects", link: "/projects", active: false },
        { label: "Blog", link: "/blog", active: false },
        // { label: "About", link: "/about", active: false },
        { label: "Contact", link: "/contact", active: false },
        { label: "Admin", link: "/admin", active: false, privilege: "ADMIN" },
    ]

    private cleanup(e: any) {
        if (this.toggledItem) {
            if (e.target.classList.value.indexOf('dropdown') === -1) {
                this.toggledItem.toggled = false;
                this.toggledItem = void 0;
                this.$forceUpdate();
            }
        }

        if (this.hoveredItem) {
            if (e.target.classList.value.indexOf('hover-trigger') === -1) {
                this.hoveredItem = void 0;
                this.$forceUpdate();
            }
        }
    }

    private getItem(path: string): IMenuItem | undefined {
        for (const item of this.menuItems) {
            if (item.link === path) {
                return item;
            }

            if (item.children && typeof(item.children) !== 'function') {
                for (const child of item.children) {
                    if (child.link === path) {
                        item.active = true;
                        return child;
                    }
                }
            }
        }

        return void 0;
    }

    private async created() {
        this.tracking = new TrackingService();

        for (let i = 0; i < this.menuItems.length; i++) {
            this.menuItems[i].toggled = false;
            if (this.menuItems[i].children) {
                if (typeof(this.menuItems[i].children) === 'function') {
                    // @ts-ignore
                    this.menuItems[i].children = await this.menuItems[i].children();
                }
                // @ts-ignore
                for (let j = 0; j < this.menuItems[i].children.length; j++) {
                    // @ts-ignore
                    this.menuItems[i].children[j].parent = this.menuItems[i];
                }
            }
        }

        if (this.currentRoute.name === "Home") {
            this.currentItem = this.getItem(this.currentRoute.path);
            if (this.currentItem) this.currentItem.active = true;
            this.tracking.trackPageVisit("Home", this.getConfig("WEB_ROOT") + this.$route.path, this.$route.query.src ? this.$route.query.src as string : void 0);
        }
    }

    @Watch("currentRoute")
    private routeChange(currentRoute: Route) {
        if (this.currentItem) {
            this.currentItem.active = false;
            if (this.currentItem.parent) {
                this.currentItem.parent.active = false;
            }
        }
        this.currentItem = this.getItem(currentRoute.path);
        document.title = "Henry Walters" + (this.currentRoute.name === "Home" ? "" : " - " + currentRoute.name);
        if (this.currentItem) {
            this.currentItem.active = true;
        }

        this.tracking.trackPageVisit(currentRoute.name as string,
            this.getConfig("WEB_ROOT") + this.$route.path, 
            this.$route.query.src ? this.$route.query.src as string : void 0
        );
    }

    private toggleItem(item: IMenuItem) {
        item.toggled = !item.toggled;
        this.toggledItem = item.toggled ? item : void 0;
        this.$forceUpdate();
    }

    private isHovered(item: IMenuItem) {
        return this.hoveredItem && this.hoveredItem.link === item.link;
    }

    private hoverItem(item: IMenuItem) {
        if (!WebUtils.isMobile()) {
            item.toggled = true;
            this.toggledItem = item;
            this.$forceUpdate();
        }
        
    }

    private setHover(item: IMenuItem) {
        this.hoveredItem = item;
        this.$forceUpdate();
    }

    private goto(item: IMenuItem) {

        if (item.parent) {
            item.parent.toggled = false;
            this.$forceUpdate();
        }
        
        if (!this.currentItem || item.link !== this.currentItem.link) {
            this.$router.push({path: item.link});
        }

        
    }

    private canShow(item: IMenuItem) {
        if (item.privilege) {
            if (!this.user) return false;
            for (const privilege of this.user.privileges) {
                if (privilege === item.privilege) {
                    return true;
                }
            }
            return false;
        }
        return true;
    }

    private get currentRoute() {
        return this.$route;
    }
}

